import React, { useCallback } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, ReferenceDot
} from 'recharts';
import "./Diagram.css";

const getXTicks = (data) => {
  if (!data || data.length === 0) return [];
  const step = 10
  return data.filter((_, i) => i % step === 0).map((d) => d.x);
};

const Diagram = ({ data, selected_index, onSelectIndex, dragging, setDragging }) => {

  const selectedPoint = data?.[selected_index];

  const handleMouseDown = () => {
    setDragging(true);
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const handleMouseMove = useCallback(
    (e) => {
      if (!dragging || !data) return;
      const mouseX = e?.activeLabel;
      if (mouseX == null) return;

      // Find closest data point
      const closestIndex = data.reduce((prev, curr, idx) => {
        return Math.abs(curr.x - mouseX) < Math.abs(data[prev].x - mouseX)
          ? idx
          : prev;
      }, 0);

      onSelectIndex(closestIndex); // Update parent state
    },
    [dragging, data, onSelectIndex]
  );

  return (
    <ResponsiveContainer width="100%" height={300} style={{ userSelect: 'none' }}>
      <LineChart
        data={data}
        margin={{ bottom: 15 }}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
      >
        <CartesianGrid stroke="#ccc" />

        <XAxis
          dataKey="x"
          tickFormatter={(x) => `${x}%`}
          label={{ value: 'Percentage of electricity covered by solar (Self-sufficiency)', position: 'insideBottom', offset: -10 }}
          ticks={getXTicks(data)}
        />

        <YAxis
          // domain={[0, 50000]}
          tickFormatter={(y) => `£${y / 1000}K`}
        />

        <Tooltip
          formatter={(value, name) => [`£${value.toFixed(0)}`, name]}
          labelFormatter={(label) => `${label}%`}
        />

        <Line type="monotone" dataKey="y" stroke="#1b2124" dot={false} />

        {selectedPoint && (
          <ReferenceDot
            x={selectedPoint.x}
            y={selectedPoint.y}
            r={6}
            stroke="red"
            fill="orange"
            strokeWidth={1}
            isFront
          />
        )}
      </LineChart>
      <p className='slide'>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          style={{ verticalAlign: 'middle', marginRight: '4px' }}
        >
          <path fill="currentColor" d="M15 18l-6-6 6-6" />
        </svg>
        Slide
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          style={{ verticalAlign: 'middle', marginLeft: '4px' }}
        >
          <path fill="currentColor" d="M9 6l6 6-6 6" />
        </svg>
      </p>
    </ResponsiveContainer>
  );
};

export default Diagram;
